<template>
  <div id="deliverySite">
    <!-- 收件人 -->
    <div class="con">
      <!-- 新增地址 -->

      <div class="Newaddress">
        <div class="delete" @click="deleteAddress()">

          {{ $fanyi('删除地址') }}
        </div>
        <div @click="openAddAddressWin" class="add">
          {{ $fanyi('新增地址') }}
        </div>
      </div>
      <div class="addressList" v-if="!Nodata" v-loading="loading">
        <div class="opt" v-for="(item, index) in consignee" :key="index">
          <!-- 标题区域 -->
          <div class="headerbox">
            <div class="titlebox">
              <!-- 选择框 -->
              <input type="checkbox" class="checkOptionBox" v-model="item.checked" />
              <span class="title">{{ $fanyi('地址') }}{{ index + 1 }}</span>
              <span v-if="item.acquiescent" class="acquiescentDivContainer">
                {{ $fanyi('默认地址') }}
              </span>
            </div>

            <!-- 操作 -->
            <div class="btn">

              <img @click="edit(item)" src="../../../../assets/OrderDetails/edit.svg" alt="">

            </div>
          </div>

          <p>
            <label for="">{{ $fanyi('收件人') }}：</label>
            <span :title="item.contacts">{{ item.contacts }}</span>
          </p>
          <p>
            <label for="">{{ $fanyi('邮编') }}:</label>
            <span :title="item.zip_code">{{ item.zip_code }}</span>
          </p>

          <p>
            <label for="">{{ $fanyi('城市') }}：</label>
            <span :title="item.email">{{ item.city }}</span>
          </p>


          <p>
            <label for="">{{ $fanyi('手机') }}：</label>
            <span :title="item.mobile">{{ item.mobile }}</span>
          </p>
          <!--        <p>-->
          <!--          <label for="">{{ $fanyi("电话") }}：</label>-->
          <!--          <span :title="item.tel">{{ item.tel }}</span>-->
          <!--        </p>-->
          <p>
            <label for="">{{ $fanyi('电子邮箱') }}：</label>
            <span :title="item.email">{{ item.email }}</span>
          </p>
          <p class="address">
            <label for="">{{ $fanyi('详细地址') }}：</label>
            <span :title="item.address">{{ item.address }}</span>
          </p>
        </div>

      </div>
      <div class="Nodata" v-if="Nodata">

        <div class="NodataImg">
          <img src="../../../../assets/defaulticon/address.svg" alt="">
        </div>

        <div class="NodataText">

          {{ $fanyi('暂无收货地址') }}
        </div>

      </div>
    </div>

    <!-- 添加和 修改 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="640px" :before-close="handleClose">
      <div class="formBox">
        <el-form ref="form" :model="form" :rules="newRules" label-width="180px" :key="key">
          <el-form-item :label="$fanyi('收件人') + '：'" prop="contacts">
            <el-input size="mini" v-model="form.contacts" oninput="this.value"
              :placeholder="$fanyi('请填写收件人')"></el-input>
          </el-form-item>
          <el-form-item :label="$fanyi('邮编') + '：'" prop="zip_code">
            <el-input size="mini" v-model="form.zip_code" @blur="getCity" :placeholder="$fanyi('请输入邮编')"
              maxlength="6"></el-input>
          </el-form-item>

          <el-form-item :label="$fanyi('城市') + '：'" prop="city">
            <el-input v-model="form.city" oninput="this.value" :placeholder="$fanyi('请输入城市')">
            </el-input>
          </el-form-item>
          <el-form-item :label="$fanyi('手机') + '：'" prop="mobile">
            <div class="dianhu">

              <el-input size="mini" type="number" class=" tel" v-model="form.mobile" oninput="this.value"
                :placeholder="$fanyi('请输入电话')">
              </el-input>
            </div>
          </el-form-item>

          <el-form-item :label="$fanyi('邮箱') + '：'" prop="email">
            <el-input size="mini" v-model="form.email" oninput="this.value" :placeholder="$fanyi('请输入邮箱')"></el-input>
          </el-form-item>
          <el-form-item :label="$fanyi('地址') + '：'" prop="address" style="height: 60px">
            <el-input v-model="form.address" oninput="this.value" :placeholder="$fanyi('请输入收货地址')">
            </el-input>
          </el-form-item>
          <div class="isAcquiescent">
            <input type="checkbox" class="checkOptionBox" v-model="form.isAcquiescent" />
            <div class="isAcquiescenttext">{{ $fanyi('设为默认地址') }}</div>
          </div>
        </el-form>
        <div class="btn">
          <!-- 新增 -->
          <p v-if="isAdd" class="edit"> <button class="save" @click="$fun.debounce(useraddressAdd, 1000)">
              {{ $fanyi('确认') }}
            </button> <button class="del" @click="handleClose">
              {{ $fanyi('取消') }}
            </button>


          </p>
          <!--编辑-->
          <p class="edit" v-else>
            <button @click="useraddressUpdate" class="save">
              {{ $fanyi('确认') }}
            </button>
            <button class="del" @click="handleClose">
              {{ $fanyi('取消') }}
            </button>

          </p>


        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Areacode from '../../../../utlis/mobilephoneareacode.js'
export default {
  data() {
    // 邮箱格式检验
    var emailFormatVerify = (rule, value, callback) => {
      let emailPostfixList = [
        'qq.com',
        '163.com',
        'fastmail.com',
        'me.com',
        'email.com',
        'gmail.com',
        '126.com',
        'yahoo.com',
        'sina.com',
        'games.com',
        'rocketmail.com',
        'wow.com',
        'googlemail.com',
        'comcast.net',
        'warwick.net',
        'comcast.net',
        'twcny.rr.com',
        'hotmail.com',
        'foxmail.com',
        'Rakumartwork.com',
        'outlook.com',
        'facebook.com',
        'mail.com',
        'mac.com',
        'icloud.com',
        'zoho.com',
        'ymail.com',
        'ygm.com',
        'love.com',
        'aol.com',
        'verizon.net',
        'cs.com',
        'netzero.net',
        'Rakumart.eu',
      ]
      let index = value.indexOf('@')
      let str = value.substr(index + 1, value.length)
      if (emailPostfixList.indexOf(str) === -1) {
        callback(new Error(this.$fanyi('请输入正确的邮箱地址')))
      } else {
        callback()
      }
    }
    return {
      consignee: [], // 地址列表
      importer: [], // 进口商地址
      dialogVisible: false,
      Areacodelist: Areacode,// 区号列表
      form: {
        zip_code: '',
      },
      type: 1,//类型：1收件人地址，2进口商地址
      loading: false,
      title: '',
      Nodata: false,
      isAdd: false,
      country: '+0038',// 区号
      key: 'fsddsfa',
      newRules: {
        zip_code: [
          { required: true, message: this.$fanyi('不能为空'), trigger: 'blur' },
          {
            pattern: /^(\w){6}$/,
            message: this.$fanyi('邮编输入错误'),
            trigger: 'blur',
          },
        ],
        contacts: [
          { required: true, message: this.$fanyi('不能为空'), trigger: 'blur' },
        ],
        address: [
          { required: true, message: this.$fanyi('不能为空'), trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: this.$fanyi('不能为空'), trigger: 'blur' },
          // {
          //   required: true,
          //   pattern: /^(\w){10}$/,
          //   message: this.$fanyi('手机号输入错误'),
          //   trigger: 'blur',
          // },
        ],
        city: [
          { required: true, message: this.$fanyi('不能为空'), trigger: 'blur' },
        ],
        state: [
          { required: true, message: this.$fanyi('不能为空'), trigger: 'blur' },
        ],
        tel: [
          {
            required: true,
            message: this.$fanyi('不能为空'),
            trigger: 'blur,change',
          },
        ],
        email: [
          {
            required: true,
            message: this.$fanyi('不能为空'),
            trigger: 'blur',
          },
          // {
          //   pattern: /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/,
          //   message: this.$fanyi('请输入正确的邮箱地址'),
          //   trigger: ['blur'],
          // },
          // {
          //   validator: emailFormatVerify,
          //   trigger: 'blur',
          // },
        ],
        company: [
          { required: true, message: this.$fanyi('不能为空'), trigger: 'blur' },
        ],
      },

    }
  },
  created() {
    this.useraddressList()
  },
  methods: {
    handleClose(done) {
      this.dialogVisible = false
      this.form = {
        type: this.type,
        company: '',
        zip_code: '',
        address: '',
        city: '',
        state: '',
        contacts: '',
        mobile: '',
        tel: '',
        email: '',
        cnpj: '',
        mark: '',
        acquiescent: 0,
        isAcquiescent: false,
      }

    },
    // 添加地址
    useraddressAdd() {
      this.form.isAcquiescent
        ? (this.form.acquiescent = 1)
        : (this.form.acquiescent = 0)
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.useraddressAdd(this.form).then((res) => {
            if (res.code != 0) return this.$message.error(this.$fanyi(res.msg))
            this.$message.success(this.$fanyi(res.msg))
            this.useraddressList()
            this.dialogVisible = false
          })
        }
      })
    },
    // 编辑地址
    useraddressUpdate() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
        } else {
          return false
        }
      })
      this.form.isAcquiescent
        ? (this.form.acquiescent = 1)
        : (this.form.acquiescent = 0)
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.useraddressUpdate(this.form).then((res) => {
            if (res.code != 0) return this.$message.error(this.$fanyi(res.msg))
            this.$message.success(this.$fanyi(res.msg))
            this.useraddressList()
            this.dialogVisible = false
          })
        }
      })
    },
    //根据邮编更新城市
    getCity() {
      if (this.form.zip_code != '') {
        this.$api.getAcquisitionCity({ zip_code: this.form.zip_code }).then((res) => {
          if (res.data.length != 0) {
            this.form.city = res.data[0].ru_city;
          }
        })
      }
    },
    // 打开新增地址弹窗
    openAddAddressWin() {
      this.dialogVisible = true
      this.key = Math.random().toString(36).slice(-8);
      this.form = {
        type: this.type,
        company: '',
        zip_code: '',
        address: '',
        city: '',
        state: '',
        mobile: '',
        tel: '',
        email: '',
        cnpj: '',
        mark: '',
        acquiescent: 0,
        isAcquiescent: false,
      }
      this.isAdd = true
      this.title = this.$fanyi('新增地址')
    },
    // 显示编辑框
    edit(item) {
      item.isAcquiescent = item.acquiescent
      let data = JSON.stringify(item)
      this.form = JSON.parse(data)
      this.title = this.$fanyi('编辑地址')
      this.isAdd = false
      this.dialogVisible = true
      this.key = Math.random().toString(36).slice(-8);
    },
    // 删除
    useraddressDelete(id) {
      let msg = this.$fanyi('是否删除当前地址?')
      this.$confirm(
        msg,
        this.$fanyi('删除'),
        {
          cancelButtonText: this.$fanyi('取消'),
          confirmButtonText: this.$fanyi('确定'),
          customClass: 'message-logout'
        }
      )
        .then(() => {
          this.$api.useraddressDelete({ id: id }).then((res) => {
            if (res.code != 0) return this.$message.error(this.$fanyi(res.msg))
            this.$message.success(this.$fanyi('成功删除地址'))
            this.useraddressList()
            this.dialogVisible = false
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: this.$fanyi('删除取消'),
          // })
        })
    },

    // 获取数据
    useraddressList() {
      this.consignee = []
      this.importer = []
      this.loading = true
      this.$api.useraddressList().then((res) => {
        this.loading = false
        if (res.data.consignee) {
          this.consignee = res.data.consignee
        }
        if (res.data.importer) {
          this.importer = res.data.importer
        }
      })
    },
    // 删除地址
    deleteAddress() {
      if (this.consignee.some((item) => item.checked == true)) {
        let id = []

        this.consignee.forEach((item) => {
          if (item.checked == true) {
            id.push(item.id)
          }

        })
        this.useraddressDelete(id)
      } else {
        this.$message({
          message: this.$fanyi('请选择要删除的地址'),
          type: 'warning'
        });
      }
    }
  },
}
</script>
<style lang="scss">
.message-logout {
  width: 480px;
  height: 240px;
  background: #FFFFFF;
  border-radius: 20px;

  .el-message-box__header {

    display: flex;
    justify-content: flex-start;
    font-weight: bold;
    height: 68px;
    align-items: flex-end;
    font-size: 16px;
    color: #121212;
    padding-left: 40px;

    .el-icon-warning {
      display: none;
    }
  }

  .el-icon-close {
    font-weight: 700;
    font-size: 24px;
    margin-right: 8px;
    color: #121212;

    &:hover {
      color: #121212 !important;
    }
  }

  .el-message-box__content {
    padding: 30px 40px;
    font-weight: 500;
    font-size: 14px;
    color: #121212;
    text-align: center;
    line-height: 20px;
  }

  .el-message-box__btns {

    padding: 0 40px;
    background: #FFFFFF;
    border-radius: 20px;

    justify-content: center;
    display: flex;
    flex-direction: row-reverse;

    /* 反转子元素顺序 */
    // 翻转
    .el-button {
      &:last-child {
        min-width: 120px;
        height: 40px;
        background: #D12A1D;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        padding: 0 15px;
        border-radius: 10px;
        margin-left: 0px;
        margin-right: 20px;
      }

      &:first-child {
        min-width: 120px;
        height: 40px;
        background: #FFFFFF;
        padding: 0 15px;
        border-radius: 10px;
        font-weight: 400;
        font-size: 14px;
        color: #222222;
        border: 1px solid #DFDFDF;
      }
    }


  }
}
</style>
<style lang="scss" scoped>
@import '../../../../css/mixin';

#deliverySite {
  width: 1060px;

  background: #FFFFFF;
  padding: 30px;
  border-radius: 20px;



  .con {
    background: #ffffff;
    border-radius: 6px;

    .Newaddress {

      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;

      .add {

        height: 40px;
        background: #D12A1D;
        border-radius: 12px;
        display: flex;
        align-items: center;
        padding: 0 15px;
        justify-content: center;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 20px;

        &:hover {
          cursor: pointer;
        }

      }

      .delete {

        font-weight: 400;
        font-size: 16px;
        color: #121212;
        line-height: 20px;
        height: 40px;
        border-radius: 12px;
        border: 1px solid #DFDFDF;
        padding: 0 15px;
        display: flex;
        align-items: center;
        margin-right: 20px;

        &:hover {
          cursor: pointer;
        }

        justify-content: center;
      }
    }

    .addressList {

      min-height: 200px;

      .opt {
        width: 1000px;

        background: #FFFFFF;
        border-radius: 20px;
        border: 1px solid #DFDFDF;
        margin-bottom: 20px;
        padding: 30px;


        .headerbox {

          display: flex;
          align-items: center;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;

          .titlebox {
            display: flex;
            align-items: center;

            input[type='checkbox'] {
              background-color: #fff;
              -webkit-appearance: none;
              border: 1px solid #c0c4cc;
              border-radius: 6px;
              outline: none;
            }

            input[type='checkbox']:checked {
              background-color: #e40000;

              border: 1px solid #e40000;

              &::after {
                height: 4px;
                // 放大
                width: 9px;


              }
            }

            .checkOptionBox {
              margin-right: 10px;

              &:hover {
                cursor: pointer;
              }
            }

            .title {
              font-weight: bold;
              display: flex;
              align-items: center;
              font-size: 18px;
              color: #121212;
              line-height: 20px;
              margin-right: 20px;
            }

            .acquiescentDivContainer {
              min-width: 160px;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0 10px;
              height: 28px;
              background: #FAE9E8;
              border-radius: 8px;
              font-weight: 400;
              font-size: 14px;
              color: #D12A1D;
              line-height: 20px;
            }
          }

          .btn {
            img {
              width: 20px;
              height: 20px;

              &:hover {
                cursor: pointer;
              }
            }


          }

        }

        p {
          display: flex;
          margin-bottom: 10px;
          min-height: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          line-height: 20px;

          &:last-child {
            margin-bottom: 0px;
          }

          label {
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            line-height: 20px;
          }

          span {
            max-width: 700px;
            font-weight: 550;
            font-size: 16px;
            color: #121212;
            line-height: 20px;
            text-align: right;
          }

          &:last-child {
            margin-bottom: 0px;
          }
        }
      }
    }

    .Nodata {
      display: flex;
      align-items: center;
      height: 360px;
      padding-top: 58px;
      flex-direction: column;

      .NodataImg {
        width: 160px;
        height: 160px;

        img {
          width: 100%;
          height: 100%;
        }


        margin-bottom: 30px;
      }

      .NodataText {
        font-weight: normal;
        font-size: 24px;
        color: #121212;
        line-height: 20px;
      }

    }

  }
}

/deep/.el-dialog {
  background: #FFFFFF;
  border-radius: 20px;
  height: 670px;
  padding: 40px;

  .el-dialog__header {

    padding: 0px;
    height: 20px !important;
    border: none;
    margin-top: 10px;

    .el-dialog__title {
      font-weight: 600;
      font-size: 16px;
      color: #121212;
      line-height: 20px;
    }

    .el-icon-close {
      font-size: 22px;
      margin-right: 18px;
      color: #000;
      font-weight: bold;
    }
  }

  .el-dialog__body {
    padding: 0px !important;

    .formBox {
      padding: 0px;
      padding-top: 20px;



      .el-form-item__label {

        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        justify-content: flex-end;
        display: flex;
        align-items: center;
        min-height: 50px;
        padding-right: 0px;

      }

      .el-form-item {
        height: 50px;

      }

      .el-input__inner {
        width: 380px;
        height: 50px !important;
        background: #ffffff;
        border-radius: 12px;
        border: 1px solid #DFDFDF;

      }

      .isAcquiescent {
        display: flex;
        align-items: center;
        height: 30px;
        margin-bottom: 30px;

        input[type='checkbox'] {
          background-color: #fff;
          -webkit-appearance: none;
          border: 1px solid #c0c4cc;
          border-radius: 6px;
          outline: none;
        }

        input[type='checkbox']:checked {
          background-color: #e40000;

          border: 1px solid #e40000;

          &::after {
            height: 4px;
            // 放大
            width: 9px;


          }
        }

        div {
          font-weight: 400;
          font-size: 14px;
          color: #121212;
          line-height: 16px;
          margin-left: 18px;
        }
      }
    }

    .btn {
      text-align: left;


      .edit {
        display: flex;
        justify-content: center;
        align-items: center;

        .del {
          min-width: 120px;
          height: 40px;
          background: #FFFFFF;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 15px;
          font-weight: 400;
          font-size: 14px;
          border: 1px solid #DFDFDF;
          color: #222222;

        }

        .save {
          min-width: 120px;
          height: 40px;
          background: #D12A1D;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 15px;
          font-weight: 400;
          font-size: 14px;
          color: #FFFFFF;
          margin-right: 10px;
          margin-right: 20px;
        }
      }
    }



  }
}
</style>
